import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"justify":"end"}},[_c(VCol,{attrs:{"cols":"6","md":"3"}},[_c(VBtn,{attrs:{"block":"","depressed":"","color":"primary","disabled":!_vm.isFormValid},on:{"click":_vm.save}},[_vm._v("\n      "+_vm._s(this.acceptLabel ? this.acceptLabel : 'save')+"\n    ")])],1),_c(VCol,{staticClass:"pl-2",attrs:{"cols":"6","md":"3"}},[_c(VBtn,{attrs:{"block":"","outlined":"","depressed":""},on:{"click":_vm.cancel}},[_vm._v("\n      "+_vm._s(this.cancelLabel ? this.cancelLabel : 'cancel')+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }